import { UI_TAGS } from "@/presentation/helpers/uiTags.js";

export function createGameTextInstruction(k, textString, config = {}) {
    const size = config.size || 48;
    const font = config.font || "lilita";
    const color = config.color || k.rgb(255, 70, 70);
    const startPos = config.pos || k.center();
    const bounceHeight = config.bounceHeight || 12;
    const bounceSpeed = config.bounceSpeed || 6;
    const zIndex = config.z || 100;
    const customTag = config.tag || "";
    const isBouncing = config.isBouncing || false;

    const textActor = k.add([
        k.text(textString, { size: size, font: font, align: "center" }),
        k.pos(startPos),
        k.anchor("center"),
        k.color(color),
        k.z(zIndex),
        UI_TAGS.TEXT_INSTRUCTION,
        customTag
    ]);

    // Save coordinates
    const baseX = startPos.x;
    const baseY = startPos.y;

    if(isBouncing) {
        textActor.onUpdate(() => {
            const bounceOffset = Math.sin(k.time() * bounceSpeed) * bounceHeight;
            textActor.pos = k.vec2(baseX, baseY + bounceOffset);
        });
    }

    textActor.remove = () => {
        textActor.destroy();
    };

    return textActor;
}